import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiAlertCircle, FiCheckCircle, FiMail } from 'react-icons/fi';
import authService from '../utils/auth.js';
import AuthShell from './AuthShell.jsx';

function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await authService.verifyEmail(token);
        setStatus('success');
        setMessage(response.message);
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (error) {
        setStatus('error');
        setMessage(error.message);
      }
    };

    if (token) {
      verifyEmail();
    }
  }, [token, navigate]);

  return (
    <AuthShell>
      <div className="auth-card">
        <div className="auth-header">
          <span className="auth-icon" aria-hidden="true"><FiMail /></span>
          <h1>Email verification</h1>
          <p>Confirming your NovaBotX&trade; account</p>
        </div>

        {status === 'verifying' && (
          <div className="auth-result" role="status">
            <span className="auth-result-icon is-loading" aria-hidden="true"><span className="auth-spinner is-lg" /></span>
            <p className="auth-result-text">Verifying your email address...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="auth-result">
            <span className="auth-result-icon is-success" aria-hidden="true"><FiCheckCircle /></span>
            <div className="auth-alert auth-alert-success" role="status">
              <span className="auth-alert-text">{message}</span>
            </div>
            <p className="auth-result-text">Redirecting to login page in 3 seconds...</p>
            <button
              type="button"
              className="auth-button auth-button-primary"
              onClick={() => navigate('/login')}
            >
              Go to Login
            </button>
          </div>
        )}

        {status === 'error' && (
          <div className="auth-result">
            <span className="auth-result-icon is-error" aria-hidden="true"><FiAlertCircle /></span>
            <div className="auth-alert auth-alert-error" role="alert">
              <span className="auth-alert-text">{message}</span>
            </div>
            <button
              type="button"
              className="auth-button auth-button-primary"
              onClick={() => navigate('/login')}
            >
              Back to Login
            </button>
          </div>
        )}
      </div>
    </AuthShell>
  );
}

export default VerifyEmail;
